import Bridge from './Bridge'

new Bridge()
